import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BarChartIcon from '@mui/icons-material/BarChart';
import RuleIcon from '@mui/icons-material/Gavel';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AirlinesIcon from '@mui/icons-material/Airlines';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditNoteIcon from '@mui/icons-material/EditNote';
import ScienceIcon from '@mui/icons-material/Science';
import HistoryIcon from '@mui/icons-material/History';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ApprovalIcon from '@mui/icons-material/Approval';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CodeIcon from '@mui/icons-material/Code';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PeopleIcon from '@mui/icons-material/People';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

const menuItems = [
  { id: 'overview', label: 'Overview', icon: <DashboardIcon /> },
  { id: 'analytics', label: 'Analytics', icon: <BarChartIcon /> },
  { divider: true },
  { id: 'rules', label: 'Fee Rules', icon: <RuleIcon /> },
  { id: 'ai-assistant', label: 'AI Rule Assistant', icon: <SmartToyIcon /> },
  { id: 'add-rule', label: 'Add New Rule', icon: <AddCircleIcon /> },
  { id: 'bulk-edit', label: 'Bulk Edit & Dates', icon: <EditNoteIcon /> },
  { id: 'rule-health', label: 'Rule Health', icon: <HealthAndSafetyIcon /> },
  { divider: true },
  { id: 'locations', label: 'Location Groups', icon: <LocationOnIcon /> },
  { id: 'carriers', label: 'Carrier Groups', icon: <AirlinesIcon /> },
  { divider: true },
  { id: 'approvals', label: 'Approvals', icon: <ApprovalIcon /> },
  { id: 'push-server', label: 'Push to Google', icon: <CloudUploadIcon /> },
  { id: 'raw-editor', label: 'Raw Editor', icon: <CodeIcon /> },
  { id: 'upload', label: 'Upload XML', icon: <UploadFileIcon /> },
  { id: 'test-rules', label: 'Test Rules', icon: <ScienceIcon /> },
  { id: 'changelog', label: 'Change Log', icon: <HistoryIcon /> },
  { divider: true },
  { id: 'agent-management', label: 'Manage Agents', icon: <PeopleIcon />, adminOnly: true },
];

export default function Sidebar({ currentPage, onNavigate, user }) {
  return (
    <Box sx={{
      width: 250,
      minWidth: 250,
      flexShrink: 0,
      bgcolor: 'white',
      borderRight: '1px solid #e0e0e0',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      height: '100vh',
      position: 'sticky',
      top: 0,
    }}>
      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <img
            src={`${process.env.PUBLIC_URL}/travomint-logo.webp`}
            alt="Travomint"
            style={{ height: 22, objectFit: 'contain' }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'primary.main' }}>
            GFS Rule
          </Typography>
        </Box>

      </Box>
      <List sx={{ flex: 1, py: 1 }}>
        {menuItems.filter(item => !item.adminOnly || user?.role === 'ADMIN').map((item, idx) => {
          if (item.divider) return <Divider key={`div-${idx}`} sx={{ my: 1 }} />;
          return (
            <ListItemButton
              key={item.id}
              selected={currentPage === item.id}
              onClick={() => onNavigate(item.id)}
              sx={{
                mx: 1,
                borderRadius: 2,
                mb: 0.5,
                ...(item.id === 'ai-assistant' && currentPage !== 'ai-assistant' ? {
                  border: '1.5px solid',
                  borderColor: 'primary.main',
                  boxShadow: '0 0 8px rgba(25, 118, 210, 0.2)',
                  background: 'linear-gradient(90deg, rgba(25,118,210,0.05) 0%, rgba(156,39,176,0.05) 100%)',
                } : {}),
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'white',
                  '& .MuiListItemIcon-root': { color: 'white' },
                  '&:hover': { bgcolor: 'primary.dark' },
                  ...(item.id === 'ai-assistant' ? { border: 'none', boxShadow: '0 0 12px rgba(25, 118, 210, 0.3)' } : {}),
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 13.5 }} />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
}
